module.exports = __webpack_public_path__ + "materialdesignicons-webfont.c28acdf1c1f9c45ff40b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/mdi/fonts/materialdesignicons-webfont.eot
// module id = ../../../../mdi/fonts/materialdesignicons-webfont.eot
// module chunks = styles